export default "d2927fb890e5a3e0.svg"